export default __webpack_public_path__ + "static/media/iconCv.572064cf.svg";